<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-row>
            <v-col align="center">
                <v-text-field class="centered-input" v-model="search" append-icon="search" label="Find pages..."
                    single-line hide-details style="width: 50%"></v-text-field>
            </v-col>
        </v-row>

        <v-row dense>
            <v-col v-for="linkname in filteredSortSearchList" :key="linkname.name" :cols="linkname.flex">
                <router-link :to="{ name: linkname.name }" style="text-decoration: none">
                    <v-card style="margin: 8px;" id="card-hover">
                        <br />
                        <v-img height="120px">
                            <center>
                                <v-avatar class="avatar-icon" size="70">
                                    <span>
                                        <v-icon size="55" class="link-icon">{{ linkname.icon }}</v-icon>
                                    </span>
                                </v-avatar>
                                <v-card-title v-text="linkname.textval" class="card-title"></v-card-title>
                            </center>
                        </v-img>
                        <v-card-actions>

                            <v-avatar v-if="linkname.size == 0" color="red darken-1" size="22">
                                <span class="white--text" :title="'#' + linkname.size + ' Field Added'">{{ linkname.size
                                    }}</span>
                            </v-avatar>
                            <v-avatar v-else color="success" size="22">
                                <span class="white--text" :title="'#' + linkname.size + ' Field Added'">{{ linkname.size
                                    }}</span>
                            </v-avatar>
                            <v-spacer></v-spacer>

                            <router-link :to="{ name: linkname.name }" style="text-decoration: none">
                                <v-btn icon size="22">
                                    <v-icon :title="'Click here to Add ' + linkname.textval" class="add-plus-icon"
                                        color="info">mdi-plus-circle</v-icon>
                                </v-btn>
                            </router-link>
                        </v-card-actions>
                    </v-card>
                </router-link>
            </v-col>
        </v-row>

    </div>
</template>

<script>
import axios from 'axios'
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },

    data() {
        return {
            routerLinkList: [],
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            search: '',
        };
    }, // end of data()
    mounted() {
        axios.get("EduStore/edustoreMaster")
            .then(res => {
                window.console.log("res" + res.data)
                if (res.data.msg == "200") {
                    this.data = res.data
                    this.routerLinkList = res.data.routerLinkList
                    console.log(this.data)
                }
                else {
                }
            })
            .catch(error => {
                window.console.log(error)
            })
    },
    computed: {
        filteredSortSearchList() {
            function compare(a, b) {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
            }
            if (!this.search) return this.routerLinkList.sort(compare);

            return this.routerLinkList.filter(tbdata => {
                return tbdata.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
            })
        }

    } //end of computed()

};
</script>
<style scoped>
.card-title {
    font-weight: 500;
    font-size: 16px;
    color: #424242;
    transition: color 0.3s ease-in-out;
}

.add-plus-icon {
    color: white;
    /* background: #1E88E5; */
    border-radius: 50%;
    /* transition: background 0.3s ease-in-out, transform 0.2s ease-in-out; */
}

.add-plus-icon:hover {
    background: #283593;
    transform: scale(1.1);
}

.avatar-icon {
    border: 2px solid #0000001a;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    transition: border 0.3s ease-in-out;
}

.link-icon {
    color: #3f51b5;
    font-size: 60px;
    transition: color 0.3s ease-in-out;
}

#card-hover {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
    transition: transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
    background: white;
}

#card-hover:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
    background: linear-gradient(135deg, #e3f2fd, #bbdefb);
}

#card-hover:hover .link-icon {
    color: #1a237e;
}

#card-hover:hover .avatar-icon {
    border-color: #1a237e;
    background: white;
}

#card-hover:hover .card-title {
    color: #1a237e;
}

</style>